// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__FJpZF","inputWrap":"CustomTip_inputWrap__3FuK_"};